var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content container",attrs:{"id":"not-found"}},[_c('h3',[_vm._v("Uh, oh!")]),_c('p',[_vm._v("Looks like you took a wrong turn! The page you were looking for doesn't exist.")]),_c('img',{attrs:{"src":"/assets/images/logo-notfound.png"}})])
}]

export { render, staticRenderFns }